// The pieces the room and desk survey forms share: the styles, a question
// card with the gold rule under its title, and the choice pills.
import { listOf } from '../../utils/siteSurveys';

export const box = 'border border-gray-200 rounded px-2 py-1.5 text-[11px] bg-white';
export const input = `w-full ${box}`;
export const label = 'block text-[9px] font-semibold text-gray-500 uppercase mb-0.5';
const btn = 'px-3 py-1.5 text-[10px] font-bold rounded border';
export const btnNavy = `${btn} bg-navy text-white border-navy hover:bg-navy/80 disabled:opacity-50`;
export const btnPlain = `${btn} bg-white text-gray-700 border-gray-200 hover:border-gold disabled:opacity-50`;

export function Question({ n, title, hint, children, tour }) {
  return (
    <section data-tour={tour} className="bg-white border border-gray-200 rounded p-3 mb-3">
      <h3 className="text-[12px] font-extrabold text-navy pb-1 mb-2 border-b-2 border-gold">{n ? `Q${n}. ` : ''}{title}</h3>
      {hint && <div className="text-[10px] text-gray-500 mb-2">{hint}</div>}
      {children}
    </section>
  );
}

/** One choice from a set, as pills; pressing the chosen one clears it back to blank (standard). */
export function Pick({ options, value, onChange, disabled }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {Object.entries(options).map(([k, l]) => (
        <button key={k} type="button" disabled={disabled} onClick={() => onChange(value === k ? null : k)} aria-pressed={value === k}
          className={`px-2.5 py-1 text-[10px] font-semibold rounded-full border ${value === k ? 'bg-navy text-white border-navy' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400'} disabled:opacity-60`}>
          {l}
        </button>
      ))}
    </div>
  );
}

/** Any number from a set, kept as a comma list like the server stores it. */
export function PickMany({ options, value, onChange, disabled }) {
  const chosen = listOf(value);
  const toggle = (k) => onChange((chosen.includes(k) ? chosen.filter(x => x !== k) : [...chosen, k]).join(',') || null);
  return (
    <div className="flex flex-wrap gap-1.5">
      {Object.entries(options).map(([k, l]) => (
        <button key={k} type="button" disabled={disabled} onClick={() => toggle(k)} aria-pressed={chosen.includes(k)}
          className={`px-2.5 py-1 text-[10px] font-semibold rounded-full border ${chosen.includes(k) ? 'bg-navy text-white border-navy' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400'} disabled:opacity-60`}>
          {l}
        </button>
      ))}
    </div>
  );
}

